import { Flex, Text } from "@chakra-ui/react";
import Field from "ui/components/Input/Field";
import { useForm } from "react-hook-form";
import PrimaryButton from "components/Button/PrimaryButton";
import { Checkbox } from "@chakra-ui/checkbox";
import { useState } from "react";
import RangeDates from "./components/RangeDates";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useLoading } from "ui/components/GlobalLoading";
import { ParceiroDisponibilidadeItem } from "core/features/parceiros/typings/index";
import useSaveDisponibilidadeParceiro from "core/features/parceiros/hooks/useSaveDisponibilidadeParceiro";
import useDisponibilidadeParceiro from "core/features/parceiros/hooks/useDisponibilidadeParceiro";

function HorarioDeFuncionamento({ idParceiro }: { idParceiro: string }) {
  const [check, setCheck] = useState(true);

  const { data: defaultData } = useDisponibilidadeParceiro(idParceiro);

  const { isLoading, mutate: handleSave } =
    useSaveDisponibilidadeParceiro(idParceiro);

  const { handleSubmit, reset, control } = useForm<{
    items: ParceiroDisponibilidadeItem[];
  }>({
    defaultValues: {
      items: [],
    },
  });

  const _handleSave = (values: { items: ParceiroDisponibilidadeItem[] }) => {
    handleSave(
      {
        items: values.items || [],
      },
      {
        onError: (err) => {
          showErrorAxios(err);
        },
        onSuccess: () => {
          showSuccess();
        },
      }
    );
  };

  useEffect(() => {
    if (!check) {
      reset({ items: defaultData || [] });
    }
  }, [defaultData, reset, check]);

  useEffect(() => {
    if (defaultData?.length) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  }, [defaultData]);

  useLoading(isLoading);

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Horário de Funcionamento
      </Text>

      <Checkbox isChecked={check} onChange={() => setCheck(!check)}>
        Não possui horário de funcionamento
      </Checkbox>
      {!check ? (
        <Flex mt="16px" mb="16px" w="100%" gap="8px">
          <Field
            shouldUnregister
            name="items"
            control={control}
            render={({ field }) => <RangeDates {...field} />}
          />
        </Flex>
      ) : null}

      <Flex justifyContent={"flex-end"} mt="32px">
        <PrimaryButton
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={() => {
            handleSubmit(_handleSave)();
          }}
        >
          Salvar
        </PrimaryButton>
      </Flex>
    </>
  );
}

export default HorarioDeFuncionamento;
